import html from "html-literal";
import pphotos from "../../assets/images/pphotos.jpg";

export default () => html`


  <section id="about">
<h1>Kelby Alese the Poet
</h1><br>

<div id="booking">
<img src=${pphotos} alt="Pphotos" width=500x500/><br />
</div>


 <div class="booking">


 </div>


<h1>What's the Word </h1>
<main>


<article style="color:black;">
  Kelby Alese is a Poet. She began writing at the age of 7. She performed a monologue at the age of eight for the Speech League and placed 2nd. She began performing for family and friends shortly after. In Highschool, her English teacher Mrs. Richardson  pushed her to do more with her poetry. She attended HSSU where she performed in a play titled "Dr. D". She won a Speech and Theatre Award from performing in that play which helped pay for some of her tuition. She has taught creative writing at a local homeless shelter, assisted with character letters and wrote poems for wedding, funerals, and other life occasions. She began performing at the open mic events and Talent Shows. She has also performed on RealSTLNews on their Sunday Spittas show. Kelby, went on to write a poetry book titled "Poetic Photos" and is currently writing her second book "Poetic Anxiety" as well as maintaining a greeting card business.<br>


  <p>For booking please see the information below!</p>

  <b>Check out her poems on Youtube</b></><br>

   <li><a href="https://www.youtube.com/watch?v=wvG5gq_4Drs&t=16s" target="_blank">Opportunity</a></li>
   <li><a href="https://www.youtube.com/watch?v=SujzOArEW9E&t=24s" target="_blank"> Fuse</a></li>
    <li><a href="https://www.youtube.com/watch?v=SujzOArEW9E&t=24s" target="_blank">Hello Daddy</a></li>
  </b></p>

</article><br><br>


</main>



  </section>
`;
